import { destroy as destroyForm } from 'redux-form';
import * as modalCodes from 'modules/messageSystem/constants/modalCodes';
import { addModal } from 'modules/messageSystem/actions/addModal';
import currentModal from 'modules/messageSystem/selectors/currentModal';
import { UPDATE_USER_FORM } from '../constants/formTypes';

export const invokeEditUserModal = () => (dispatch) => {
  return dispatch(addModal({
    typeId: modalCodes.EDIT_USER_MODAL,
    canAddDuplicate: false,
    preventClosingWhenDismiss: true,
    onOk: () => dispatch(destroyForm(UPDATE_USER_FORM)),
  }));
};

export const closeEditUserModal = () => (dispatch, getState) => {
  dispatch(destroyForm(UPDATE_USER_FORM));
  currentModal(getState()).onCancel();
};

export const invokeConfirmCancelModal = () => (dispatch) => {
  return dispatch(addModal({
    typeId: modalCodes.CONFIRM_CANCEL_USER_EDIT_MODAL,
    canAddDuplicate: false,
    preventClosingWhenDismiss: true,
    isForce: true,
    onOk: () => dispatch(closeEditUserModal()),
  }));
};
